<template>
  <form
    method="post"
    class="form-horizontal m-0 p-0"
    :action="route"
    v-if="authenticated"
  >
    <input type="hidden" name="_token" :value="getCsrfToken()" />

    <button
      v-if="isSubscribed"
      class="btn btn-link"
      type="submit"
      data-toggle="tooltip"
      :title="
        'Unsubscribe from &quot;' +
        categoryName +
        '&quot; category to stop recieving email notifications when new products are listed for auction'
      "
    >
      <i class="fas fa-heart fa-2x text-danger mr-1"></i>
    </button>
    <button
      v-else
      class="btn btn-link"
      type="submit"
      data-toggle="tooltip"
      :title="
        'Subscribe to &quot;' +
        categoryName +
        '&quot; category to recieve an email notification when new products are listed for auction'
      "
    >
      <i class="far fa-heart fa-2x text-danger mr-1" text-danger></i>
    </button>
  </form>
</template>

<script>
export default {
  props: {
    isSubscribed: {
      required: true,
    },
    route: {
      required: true,
    },
    categoryName: {
      required: true,
    },
  },
  data: function () {
    return { authenticated: window.authenticated };
  },
  methods: {
    getCsrfToken: function () {
      return document.querySelector('meta[name="csrf-token"]').content;
    },
  },
};
</script>
